import { PartialTranslation } from '../translations';

export const is: PartialTranslation = {
  newChat: 'Nýtt spjall',
  search: 'Leita',
  user: 'Notandi',
  settings: 'Stillingar',
  language: 'Tungumál',
  getHelp: 'Fá hjálp',
  viewAllPlans: 'Skoða allar áætlanir',
  learnMore: 'Læra meira',
  logOut: 'Skrá út',
  chooseLanguage: 'Выберите язык',
  chooseYourPreferredLanguage: 'Выберите предпочитаемый язык',
  searchLanguages: 'Поиск языков...',
  autoDetect: 'Sjálfvirk greining',
  noLanguagesFound: 'Языки не найдены',
  askAnything: 'Spyrðu um hvað sem er',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Persónulegt',
  freePlan: 'Ókeypis áætlun',
  current: 'Текущий',
  close: 'Закрыть',
  archive: 'Архивировать',
  delete: 'Удалить',
  confirmDelete: 'Вы уверены, что хотите удалить этот чат?',
  confirmArchive: 'Вы уверены, что хотите архивировать этот чат?',
  deleteCannotUndo: 'Это действие нельзя отменить.',
  archiveCanFind: 'Вы сможете найти его в списке архива после архивирования.',
  
  // 资源面板
  resources: 'Tilföng',
  addResource: 'Bæta við tilfangi',
  deleteResource: 'Удалить ресурс',
  noMatchingResourcesFound: 'Подходящие ресурсы не найдены',
  noResourcesAvailable: 'Ресурсы недоступны',
  hideResources: 'Скрыть ресурсы',
  showResources: 'Показать ресурсы',
  
  // 聊天输入框
  typeMessage: 'Skrifaðu skilaboð...',
  thinkingOptions: 'Варианты размышления',
  deleteFile: 'Удалить файл',
  clearSelection: 'Очистить выбор',
  addAttachment: 'Bæta við viðhengi',
  sendMessage: 'Senda skilaboð',
  
  // 思考模式选项
  deepInsight: 'Глубокое понимание · Поверхностный анализ',
  deepInsightDesc: 'Быстрое понимание ключевых моментов',
  deepExploration: 'Глубокое исследование · Комплексный анализ',
  deepExplorationDesc: 'Многомерное углубленное исследование',
  deepDeconstruction: 'Глубокая деконструкция · Систематический аргумент',
  deepDeconstructionDesc: 'Послойный прогрессивный анализ',
  
  // 写作模式选项
  contractReview: 'Обзор контракта · Выявление рисков',
  contractReviewDesc: 'Анализ пунктов и проверка соответствия',
  textPolish: 'Полировка текста · Профессиональное выражение',
  textPolishDesc: 'Языковая оптимизация и структурная настройка',
  legalDocuments: 'Правовые документы · Стандартный проект',
  legalDocumentsDesc: 'Профессиональное написание правовых документов',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Skrá inn',
  register: 'Nýskráning',
  welcomeBack: 'Velkomin í LawHelper',
  loginSubtitle: 'AI lögfræðirannsóknaraðstoðarmaður þinn',
  continueWithGoogle: 'Halda áfram með Google',
  continueWithMicrosoft: 'Halda áfram með Microsoft',
  continueWithWeChat: 'Halda áfram með WeChat',
  orContinueWith: 'eða halda áfram með',
  emailTab: 'Netfang',
  phoneTab: 'Sími',
  emailPlaceholder: 'Sláðu inn netfang',
  phonePlaceholder: 'Sláðu inn símanúmer',
  codePlaceholder: 'Sláðu inn 6 stafa kóða',
  sending: 'Sendi...',
  verifying: 'Staðfesti...',
  verify: 'Staðfesta',
  sendMagicLink: 'Senda töfratengil',
  getVerificationCode: 'Fá kóða',
  resendCode: 'Endursenda kóða',
  resendIn: 'Endursenda eftir',
  magicLinkSent: 'Töfratengill sendur á netfang þitt',
  magicLinkHint: 'Við sendum öruggan tengil á netfang þitt',
  otpSent: 'Staðfestingarkóði sendur',
  agreeToTerms: 'Með því að halda áfram samþykkir þú okkar',
  privacyPolicy: 'Persónuverndarstefna',
  termsOfService: 'Þjónustuskilmálar',
  and: 'og',
  privacyTitle: 'Persónuvernd þín skiptir máli',
  privacyIntro: 'Við notum vafrakökur og svipaða tækni til að veita þér bestu upplifuni.',
  essentialCookies: 'Nauðsynlegar vafrakökur',
  essentialDesc: 'Nauðsynlegar til að vefsíðan virki',
  analyticsCookies: 'Greiningarvafrakökur',
  analyticsDesc: 'Hjálpa okkur að bæta þjónustuna',
  marketingCookies: 'Markaðsvafrakökur',
  marketingDesc: 'Notaðar fyrir sérsniðið efni',
  acceptAll: 'Samþykkja allt',
  essentialOnly: 'Aðeins nauðsynlegar',
  customize: 'Sérsníða',
  savePreferences: 'Vista stillingar',
  back: 'Til baka',
  readPrivacyPolicy: 'Lestu persónuverndarstefnu okkar',
  cookiePolicy: 'Vafrakökustefna',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI endurskoðun',
  aiDraft: 'AI drög',
  smartAssistant: 'Sniðmát',

  // 知识库搜索
  enableKnowledgeSearch: 'Virkja leit',
  knowledgeSearchDesc: 'AI leitar í skjölunum þínum',
  clickToDisable: 'Slökkva',
  clickToEnable: 'Virkja',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Loka gagnaspjaldi',
  uploading: 'Hleð upp %{fileName}...',
  processing: 'Vinnsla %{fileName}...',
  uploadSuccess: '✓ %{fileName} hlaðið upp',
  uploadError: '✗ Upphleðsla mistókst: %{error}',
  quickAnswer: 'Fljótt svar',
  quickAnswerDesc: 'Fljótt svar við einföldum spurningum',
  cancelRequest: 'Hætta við',
  library: 'Bókasafn',
  filterAll: 'Allt',
  filterChat: 'Spjöll',
  filterReview: 'Yfirferð',
  filterDraft: 'Drög',
  filterTemplate: 'Sniðmát',
  filterForm: 'Eyðublað',
  thinking: 'Hugsar...',
  thinkingProcess: 'Hugsanaferli',
  analyzingLegalLogic: 'Greini lagalega rökfræði...',
  lawhelperThinking: 'Lawhelper hugsar...',
  serviceError: 'Þjónustuvilla',
  uploaded: 'Hlaðið upp',
  settingsGeneral: 'Almennt',
  settingsNotifications: 'Tilkynningar',
  settingsAppearance: 'Útlit',
  settingsProfile: 'Prófíll',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Litastilling',
  settingsLight: 'Ljóst',
  settingsDark: 'Dökkt',
  settingsSystem: 'Kerfi',
  about: 'Um',
  reviewTitle: 'Skjalaskoðun',
  exitReview: 'Hætta skoðun',
  uploadPrompt: 'Hlaðið upp PDF til skoðunar',
  uploadButton: 'Velja skrá',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Skoðar...',
  reviewComplete: 'Skoðun lokið',
  issuesFound: '%{count} vandamál fundin',
  draftTitle: 'Gerð lagaskjals',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Býr til...',
  generatedSuccess: '✅ Skjal búið til!',
  drafterWelcome: 'Velkomin í AI skjalaaðstoð',
  drafterYouCan: 'Þú getur:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Dæmi:',
  drafterExampleRental: '"Búðu til leigusamning"',
  drafterExampleLabor: '"Fylltu út ráðningarsamning"',
  drafterInputPlaceholder: 'Lýstu þörfum þínum...',
  drafterThinking: 'Hugsar...',
  drafterHistoryTitle: 'Saga',
  drafterNoHistory: 'Engin saga',
  drafterNewChat: 'Nýtt spjall',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Vista skjal',
  drafterDownload: 'Hlaða niður skjali',
  drafterUndo: 'Afturkalla',
  drafterRedo: 'Endurtaka',
  drafterBold: 'Feitletrað',
  drafterItalic: 'Skáletrað',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Hætta',
  drafterConfirm: 'Staðfesta',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI verkflæði',
  workflowRunning: 'Keyrir...',
  workflowReady: 'Tilbúið',
  workflowCompleted: 'Lokið',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Samþykkja breytingar',
  rejectChanges: 'Hafna breytingum',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Stöðva',
  restartWorkflow: 'Restart',
  startDrafting: 'Hefja gerð',
  interrupt: 'Stop',
  documentSubject: 'Efni skjals *',
  documentType: 'Skjalagerð',
  jurisdiction: 'Lögsaga',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Samningur',
  docTypeAgreement: 'Samkomulag',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Bréf',
  docTypePetition: 'Petition',
  docTypeWill: 'Erfðaskrá',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'Kína',
  countryUSA: 'Bandaríkin',
  countryGermany: 'Þýskaland',
  countryJapan: 'Japan',
  countryFrance: 'Frakkland',
  countryUK: 'Bretland',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'Snjöll skjalaaðstoð',
  smartDocChatTitle: 'AI skjalaaðstoð',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Velja skrá',
  smartDocOr: 'eða',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'Villa',
  unknownError: 'Óþekkt villa',
  file: 'Skrá',
  loading: 'Hleður...',
  localFolders: 'Staðbundnar möppur',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Vista',
  renameFile: 'Endurnefna',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI greining',
};
